export const pageTitle = title => {
  return (document.title =
    title + ' | Crescent IT Solutions');
};
